module.exports = __webpack_public_path__ + "037.e10edf85.png";